import { render } from "./TitleApi.vue?vue&type=template&id=daed4a12&scoped=true"
import script from "./TitleApi.vue?vue&type=script&lang=js"
export * from "./TitleApi.vue?vue&type=script&lang=js"

import "./TitleApi.vue?vue&type=style&index=0&id=daed4a12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daed4a12"]])

export default __exports__